/* global BigInt */
// Presentation only. All monetary accumulation belongs to the backend.
export function reaisDeCentavos(value) {
  if (value == null) return null;
  const amount = BigInt(value), abs = amount < 0n ? -amount : amount;
  return `${amount < 0n ? '-' : ''}${abs / 100n}.${String(abs % 100n).padStart(2, '0')}`;
}
export function mapaSaldos(dias = []) {
  return Object.fromEntries(dias.map(d => [d.data, reaisDeCentavos(d.saldo_encerramento_centavos)]));
}
export function totaisResumo(resumo = {}) {
  return { rec: resumo.total_receitas, desAbs: resumo.total_despesas_pos, saldo: resumo.movimento_liquido };
}
export function linhasReferencias(referencias = []) {
  return referencias.map(r => [r.data, `Referência #${r.id}`, reaisDeCentavos(r.saldo_calculado_antes_centavos),
    reaisDeCentavos(r.saldo_declarado_centavos), reaisDeCentavos(r.diferenca_centavos)]);
}
export function linhasResumo(resumo = {}) {
  return [['Saldo inicial', resumo.saldo_inicio_periodo], ['Entradas', resumo.total_receitas],
    ['Saídas', resumo.total_despesas_pos], ['Diferenças de referência', resumo.diferencas_referencia],
    ['Saldo final', resumo.saldo_ao_fim_periodo]];
}
